import { authControllerAuthorizeExtensionWithAccessToken } from "@/shared/api/generated"

export function isTrustedExtensionContinuation(continuation: string): boolean {
  try {
    const target = new URL(continuation)
    const api = new URL(import.meta.env.VITE_API_URL)
    return (
      target.origin === api.origin &&
      target.pathname === "/api/auth/extension/authorize"
    )
  } catch {
    return false
  }
}

export async function completeExtensionAuth(
  continuation: string
): Promise<void> {
  const target = new URL(continuation)
  if (!isTrustedExtensionContinuation(continuation)) {
    throw new Error("Invalid extension authorization request")
  }

  const redirectUri = target.searchParams.get("redirect_uri")
  const state = target.searchParams.get("state")
  const codeChallenge = target.searchParams.get("code_challenge")
  if (!redirectUri || !state || !codeChallenge) {
    throw new Error("Invalid extension authorization request")
  }

  const data = await authControllerAuthorizeExtensionWithAccessToken({
    redirectUri,
    state,
    codeChallenge,
  })
  window.location.replace(data.redirectUrl)
}
